export default "__VITE_ASSET__5aNdGNGI__"